import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import FormLabel from './FormLabel';
import { Paragraph } from './Typography';
import { ssColorMidGrey } from '../constants/style-constants';
import { vunit } from '../lib/style-helpers';
import { linkTicketPhrasesPropTypes } from '../proptypes/link-ticket-module';

const formCss = css`
  transition: 0.4s opacity;
`;

const helperTextCss = css`
  color: ${ssColorMidGrey};
  font-size: 0.9rem;
`;

const linkTicketApiPathsCss = css`
  margin-top: ${vunit(4)};
`;

const LinkTicketForm = ({
  linkTicketApiPath,
  redirectTo,
  phrases: {
    form: formPhrases,
  },
}) => (
  <div css={formCss}>
    <form method="get" action={linkTicketApiPath}>
      <FormLabel text={formPhrases.label} id="scanCodeLabel" htmlFor="scanCode">
        <input
          type="text"
          className="form-control"
          id="scanCode"
          name="scan_code"
          aria-describedby="scanCodeDescription formErrors formMessages"
          placeholder={formPhrases.placeholder}
          required
        />
        <input type="hidden" name="redirect_to" value={redirectTo} />
        <Paragraph>
          <span css={helperTextCss} id="scanCodeDescription">{formPhrases.helperText}</span>
        </Paragraph>
      </FormLabel>
      <div css={linkTicketApiPathsCss}>
        <button className="btn btn-block btn-primary" type="submit">{formPhrases.submitButtonAlt}</button>
      </div>
    </form>
  </div>
);

LinkTicketForm.propTypes = {
  linkTicketApiPath: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
  phrases: PropTypes.shape(linkTicketPhrasesPropTypes).isRequired,
};

export default LinkTicketForm;
